'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { ROUTES, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

//* 허용된 경로(가입으로 강제 이동하지 않음).
//* `/account-integration` 포함: 통합 게이트(AccountIntegrationController)가 블로킹 우선권을 가지므로,
//* 미완성 유저가 통합 대상이어서 통합 화면에 있을 때 여기서 /kb-join으로 되튕기면 두 컨트롤러가
//* 핑퐁하며 무한 루프가 된다. 통합을 먼저 끝내면 survivor는 완료 상태라 가입 유도가 불필요하다.
const ALLOWED_PATHS = ['/join', '/kb-join', '/login', '/easy-certification', '/account-integration'];
export const JoinController = () => {
  const $ = _c(8);
  const isNewUser = useIsNewUser();
  const isKbPay = useDeviceInfoStore(_temp);
  const pathname = usePathname();
  const router = useCustomRouter();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname ? ALLOWED_PATHS.some(path => pathname.startsWith(path)) : true;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isAllowedPath = t0;
  let t1;
  let t2;
  if ($[2] !== isAllowedPath || $[3] !== isKbPay || $[4] !== isNewUser || $[5] !== router) {
    t1 = () => {
      if (isAllowedPath || !isNewUser || !isKbPay) {
        return;
      }
      router.replace(ROUTES.KB_JOIN_COMMON.withSearchParams({
        searchParams: {
          step: 1
        }
      }));
    };
    t2 = [isNewUser, isAllowedPath, isKbPay, router];
    $[2] = isAllowedPath;
    $[3] = isKbPay;
    $[4] = isNewUser;
    $[5] = router;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  return null;
};
function _temp(state) {
  return state.subDomain === SUB_DOMAIN.KB_PAY;
}